import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import {
  withToolsSiteMap,
  siteMapPropType,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { MerchantCenterSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

export const Loader = (props) => {
  const { siteMap, updateAvailability, ...others } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  return (<MerchantCenterSummaryBar {...others} siteMap={siteMap} />);
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const MerchantCenterSummaryBarLoader = withToolsSiteMap(
  React.memo(Loader),
  processorSet.all,
  ['mmc-stores/*', 'mmc-store-summary/*', 'mmc-feeds/*', 'mmc-promotions/*', 'mmc-import/*', 'mmc-settings/*']
);
